import React from 'react';
import { Row } from 'antd';
import PropTypes from 'prop-types';
import { SectionLayout } from 'components/Sections/SectionLayout';
import { WebsiteImage } from 'components/TitleDescription';

import { Heading, Companies, LogoContainer } from './styles';

const ContentfulTrustbarV1 = ({ companies, heading, trustbarBGColor }) => (
  <SectionLayout backgroundColor={trustbarBGColor}>
    <Row>
      <Heading fontSize="normal" textAlign="center">
        {heading}
      </Heading>
    </Row>
    <Companies>
      {companies?.map((logo, index) => (
        <LogoContainer key={index}>
          <WebsiteImage src={logo?.image} alt={logo?.alt} />
        </LogoContainer>
      ))}
    </Companies>
  </SectionLayout>
);

export default ContentfulTrustbarV1;

ContentfulTrustbarV1.propTypes = {
  heading: PropTypes.string,
  trustbarBGColor: PropTypes.string,
  companies: PropTypes.objectOf(PropTypes.object),
};

ContentfulTrustbarV1.defaultProps = {
  heading: 'Trusted by more than 100,000+ contractors.',
  trustbarBGColor: 'White',
  companies: null,
};
